import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import { resolveQRUrl, getRestaurantMenu, getPrintData } from '../api/client';
import { getPDFTemplateComponent } from '../templates/TemplateRegistry';
import { normalizePrintData } from '../utils/normalizeMenuData';

const SingleMenuRenderer = () => {
    const { shortcode, menuId } = useParams();
    const location = useLocation();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [templateName, setTemplateName] = useState(null);
    const [menuData, setMenuData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                // 1. Get templateName from query string
                const params = new URLSearchParams(location.search);
                let qTemplate = params.get('templateName') || 'Classic Print'; // Default to Classic Print

                setTemplateName(qTemplate);

                // 3. Fetch print-data for the menu
                const raw = await getPrintData(menuId, shortcode);

                // 4. Normalize print-data to expected format: `restaurant` + `menus` (array)
                if (!raw) {
                    console.error('No raw data received');
                    setError('Menu data not found.');
                } else {
                    try {
                        const normalized = normalizePrintData(raw);
                        setMenuData(normalized);
                    } catch (e) {
                        console.error('Failed to normalize print data', e);
                        setError('Menu data malformed.');
                    }
                }
            } catch (err) {
                console.error('Failed to load menu card', err);
                setError('Unable to load menu.');
            } finally {
                setLoading(false);
            }
        };

        if (shortcode && menuId) {
            fetchData();
        }
    }, [shortcode, menuId, location.search]);

    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: '#666' }}>
                Loading menu card...
            </div>
        );
    }

    if (error) {
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#e74c3c', marginTop: '50px' }}>
                <h2>Oops!</h2>
                <p>{error}</p>
            </div>
        );
    }

    const TemplateComponent = getPDFTemplateComponent(templateName);

    if (!TemplateComponent) {
        console.error('No template component found!');
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#e74c3c', marginTop: '50px' }}>
                <h2>Template Not Found</h2>
                <p>Template "{templateName}" is not registered.</p>
            </div>
        );
    }

    if (!menuData) {
        console.error('No menu data available to render!');
        return (
            <div style={{ padding: '20px', textAlign: 'center', color: '#e74c3c', marginTop: '50px' }}>
                <h2>No Data</h2>
                <p>Menu data is not available.</p>
            </div>
        );
    }

    // Render with isSingleMenu prop to let templates hide navigation
    return <TemplateComponent data={menuData} isSingleMenu={true} />;
};

export default SingleMenuRenderer;
